<template>
  <path
    d="M11 16.0702V7.9302C11 7.1202 10.09 6.6502 9.41998 7.1102L3.64998 11.1802C3.08998 11.5802 3.08998 12.4202 3.64998 12.8102L9.41998 16.8802C10.09 17.3502 11 16.8802 11 16.0702ZM12.66 12.8202L18.43 16.8902C19.09 17.3602 20.01 16.8802 20.01 16.0702V7.9302C20.01 7.1202 19.1 6.6502 18.43 7.1102L12.66 11.1802C12.09 11.5802 12.09 12.4202 12.66 12.8202Z"
  />
</template>
